<header class="topbar">
  <div class="topbar__left">
    <a class="brand" (click)="goHome()" aria-label="Home" role="button" tabindex="0">
      <app-logo></app-logo>
    </a>
    <div
      class="topbar__title"
      [title]="
        ((parentTitleKey$ | async) || '' | translate) +
        ((parentTitleKey$ | async) ? ' / ' : '') +
        ((pageTitle$ | async) || '')
      "
    >
      <ng-container *ngIf="parentTitleKey$ | async as pKey; else onlyChild">
        <span class="topbar__parent" [translate]="pKey || ''"></span>
        <span class="topbar__sep">/</span>
        <span class="topbar__child">{{ (pageTitle$ | async) || '' }}</span>
      </ng-container>
      <ng-template #onlyChild>
        <span class="topbar__child">{{ (pageTitle$ | async) || '' }}</span>
      </ng-template>
      <ng-container *ngIf="subtitle$ | async as subtitle">
        <span class="topbar__sep">-</span>
        <span class="topbar__child topbar__location">{{ subtitle }}</span>
      </ng-container>
    </div>
  </div>
   <div class="topbar__system-message" *ngIf="systemMessage !== ''">
    {{ systemMessage }}
  </div>

  <div class="topbar__right">
    <ng-container *ngIf="topbarActions$ | async as actions">
      <button
        *ngFor="let action of actions"
        type="button"
        mat-button
        class="topbar__action"
        [disabled]="!!action.disabled"
        (click)="runAction(action)"
      >
        <mat-icon>{{ action.icon }}</mat-icon>
        <span class="topbar__action-label">{{ action.label | translate }}</span>
      </button>
    </ng-container>

    <app-theme-toggle></app-theme-toggle>

    <div class="profile" ngbDropdown placement="bottom-end">
      <button class="profile__btn" mat-icon-button ngbDropdownToggle aria-label="Profile">
        <app-profile-icon [size]="24" [color]="'var(--collapse-icon-fill)'"></app-profile-icon>
      </button>
      <div class="profile__menu" ngbDropdownMenu>
        <div class="profile__info">
          <mat-icon class="profile__info-icon">account_circle</mat-icon>
          <div class="profile__info-text">
            <div class="gym">{{ gymName }}</div>
            <div class="name">{{ userName }}</div>
          </div>
        </div>
        <div class="profile__section" *ngIf="languages && languages.length > 1">
          <div class="profile__section-title" [translate]="'global.menu.language'">Language</div>
          <button
            class="profile__menu-item"
            *ngFor="let language of languages"
            (click)="changeLanguage(language)"
          >
            <mat-icon class="profile__menu-icon">language</mat-icon>
            <span>{{ language | findLanguageFromKey }}</span>
            <mat-icon *ngIf="activeLanguage === language" class="profile__menu-check">check</mat-icon>
          </button>
        </div>

        <a
          class="profile__menu-item"
          [href]="'https://technomedia.rs/documents/BeneFit_' + activeLanguage + '.docx'"
          target="_blank"
        >
          <mat-icon class="profile__menu-icon">menu_book</mat-icon>
          <span [translate]="'global.menu.account.manual'">Manual</span>
        </a>

        <button class="profile__menu-item" (click)="openChangePassword()">
          <mat-icon class="profile__menu-icon">lock_reset</mat-icon>
          <span [translate]="'global.menu.account.changePassword'">Change password</span>
        </button>

        <button class="profile__menu-item" (click)="logout()">
          <mat-icon class="profile__menu-icon">logout</mat-icon>
          <span [translate]="'global.menu.account.logout'">Logout</span>
        </button>
      </div>
    </div>
  </div>
</header>
